module.exports = __webpack_public_path__ + "img/trash.7df49e24.png";